const colCard = {
  xs: { span: 22 },
  md: { span: 11 },
  lg: { span: 10 },
  xl: { span: 7 },
  xxl: { span: 6 },
};

export default colCard;
